<template>
  <report-list-page
      v-if="checkAccess('sales-by-sites')"
      page-title="Sales By Sites Report"
      page-icon="mdi-sale"
      :descending="true"
      :headers="headers"
      state-end-point="report.salesBySites"
      :actions="actions"
      :show-component="showComponent"
      item-key="id"
  />
</template>

<script>
import IsAuthenticated from "../../middleware/IsAuthenticated";
import ReportListPage from "../../components/ReportListPage";
export default {
  name: "SalesBySitesReport",
  components: {ReportListPage},
  mixins: [IsAuthenticated],
  data() {
    return {
      headers: [
        {
          text: 'Invoice No',
          value: 'invoiceNo'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Site URL',
          value: 'site',
          align: 'center',
          sortable: false
        },
        {
          text: 'G.A. Price',
          align: 'right',
          value: 'generalAdminPrice'
        },
        {
          text: 'O.A Price',
          align: 'right',
          value: 'othersAdminPrice'
        },
        {
          text: 'P. Amount',
          align: 'right',
          value: 'publishableAmount'
        },
        {
          text: 'W. Price',
          align: 'right',
          value: 'articleWritingPrice'
        },
        {
          text: 'Sub Total',
          align: 'right',
          value: 'total'
        },
        {
          text: 'Discount',
          align: 'right',
          value: 'discount'
        },
        {
          text: 'Total',
          align: 'right',
          value: 'excludeDiscountTotal'
        }
      ],
      actions: {
        load: 'loadSalesBySites',
      },
      showComponent: {
        isUser: true,
        isStatus: true,
        isMethod: false,
        isEmail: true,
        isSite: true,
        isSummary: true,
        isSalesBySitesPdf: true,
        isAdminPrice: true,
      }
    }
  }
}
</script>

<style scoped>

</style>